import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, TextField } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
/**
 * @Description This function returns Delete Variant dialog.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function TabDialog({ open, setOpen, setDetailTabs }) {
    const { t } = useTranslation();
    const label = 'CONTENT.FLOW.';
    const handleClose = () => { setOpen(null); };
    const handleClick = () => {
        setDetailTabs(e => [...e, { ...values, item: open }]);
        setOpen(null);
    }

    const [values, setValues] = useState({ name: open.name, color: '#0f0' })

    const handleChange = (prop) => (event) => setValues({ ...values, [prop]: event.target.value });

    const controlProps = (item) => ({
        checked: values.color === item,
        style: { color: item },
        color: 'default',
        value: item
    });
    return (
        <Dialog maxWidth="xs" onClose={handleClose} open>
            <DialogTitle>
                <div className="dialog-header variant">
                    {t(label + 'OPEN-TAB')}
                    <Button onClick={handleClose}>
                        <Close fontSize="small" />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="dialog-body">
                    <div style={{ textAlign: 'left' }}>
                        {t(label + 'NAME')}:
                        <FormControlLabel style={{ width: 237 }} labelPlacement="start" control={
                            <TextField fullWidth onChange={handleChange('name')}
                                value={values.name} size="small" variant="outlined" />
                        }/>
                    </div>
                    <div></div>
                    <br/>
                    <span style={{ marginRight: 10 }}>{t(label + 'COLOR')}:</span>
                    <FormControlLabel style={{ margin: 0 }} control={
                    <RadioGroup row onChange={handleChange('color')}>
                        <Radio {...controlProps('#f00')} />
                        <Radio {...controlProps('#0f0')} />
                        <Radio {...controlProps('#00f')} />
                        <Radio {...controlProps('#0ff')} />
                        <Radio {...controlProps('#ffca1c')} />
                        <Radio {...controlProps('#4d841d')} />
                    </RadioGroup>} />
                    <br/>
                    <Button onClick={handleClick}>{t(label + 'ADD')}</Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}
export default TabDialog;